import styles from './Footer.module.css';


function Footer(props) {
    return (
        <footer className={styles.footer}>
            <h4>🛒ShoppingList</h4>
        </footer>
    )
    

}

export default Footer;